export const DOCUMENT_DOWNLOAD_LIST_CATEGORY_KEY = 'file' as const;
export const DOCUMENT_DOWNLOAD_LIST_COMPONENT_KEY = 'documentDownloadList' as const;
